import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { 
  Crown, Sparkles, ChevronRight, Star, Shield, Diamond, Award, 
  Music, Play, Pause, Volume2, VolumeX, Instagram, Lock, Coins, AlertTriangle
} from 'lucide-react';
import { Button } from '../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import Navbar from '../components/Navbar';
import FadeImage from '../components/FadeImage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Discord invite link for Gold members
const DISCORD_INVITE_URL = "https://discord.gg/Nw3rFE4G";

// Telegram group link
const TELEGRAM_GROUP_URL = "https://t.me/+5ttJnnkDF1oxNThk";

// Discord icon component
const DiscordIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
  </svg>
);

// Telegram icon component
const TelegramIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

// X (Twitter) icon component
const XIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

// ============== ELLA'S EIGEN FOTO'S - DEFINITIEF HARDCODED ==============
// NOOIT MEER WIJZIGEN - Dit zijn Ella's eigen geüploade foto's met correcte UUIDs
const API_BASE = process.env.REACT_APP_BACKEND_URL;
const HARDCODED_IMAGES = {
  hero: `${API_BASE}/api/media/ebd63b84-575a-48d2-a05b-33b154a62162`,           // IMG_5335.jpeg
  hero_2: `${API_BASE}/api/media/0e12bb36-741e-4307-9d64-22c8b004057f`,         // 56C54729
  gallery_1: `${API_BASE}/api/media/18354470-b5a8-42af-b35d-5b25854e4156`,      // IMG_5233.jpeg
  gallery_2: `${API_BASE}/api/media/e85135e0-1c07-4f9f-9f41-113ab6df74b9`,      // IMG_5150.jpeg
  gallery_3: `${API_BASE}/api/media/25398efc-cf42-4690-af6f-b3be09142bbf`,      // IMG_5142.jpeg
  gallery_4: `${API_BASE}/api/media/0a1a5512-e12e-489c-bf21-b7edd2c4d384`,      // IMG_5144.jpeg
  gallery_5: `${API_BASE}/api/media/29879b2b-b65d-4245-8093-e6b10be8497b`,      // IMG_5113.jpeg
  gallery_6: `${API_BASE}/api/media/0237dce4-162d-4a1a-a8b0-46e0e71f24a9`,      // 750A1496
  gallery_7: `${API_BASE}/api/media/0968d276-ad5b-49bd-9c58-815287d0bc19`,      // 0C873BAC
  gallery_8: `${API_BASE}/api/media/fe24f3e1-c5e7-4b36-985b-d6ec58070224`,      // AEF09152
  featured: `${API_BASE}/api/media/b47d028f-1368-451e-92ae-731882b5fc89`,       // IMG_5092.jpeg
  shop_featured: `${API_BASE}/api/media/ab593693-bf48-4d47-884e-cbe6b492aea2`,  // IMG_5091.jpeg
  shop_1: `${API_BASE}/api/media/2e1936eb-c4d2-4204-b162-0a9f605f3036`,         // DC0D56B6
  shop_2: `${API_BASE}/api/media/5bcdb402-731b-41c6-8bc8-7088fb9f8a09`,         // EE3AB533
  packages_hero: `${API_BASE}/api/media/d4170f20-766c-4603-8a12-955bed649aee`,  // 0E693011
  about: `${API_BASE}/api/media/15e3b6de-8361-4208-ba7c-76cb61b3fce1`,          // 079F843A
  login_bg: `${API_BASE}/api/media/bedc7476-5e55-4193-9371-817770e548f6`,       // 9C0191FB
  ella_chat: `${API_BASE}/api/media/c3738f05-1da9-4dcd-a921-bf8d49b0472c`,      // IMG_5341.jpeg
  ella_profile: `${API_BASE}/api/media/85496322-f571-428b-a286-fba5d76f6094`,   // IMG_5340.jpeg
};

// Use HARDCODED images - database is ignored
const DEFAULT_IMAGES = HARDCODED_IMAGES;

export default function Landing() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [siteImages, setSiteImages] = useState({});
  const [showAgeCheck, setShowAgeCheck] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [creditBalance, setCreditBalance] = useState(0);
  const [purchaseDialog, setPurchaseDialog] = useState(null);
  const [purchasing, setPurchasing] = useState(false);
  const [socialLinks, setSocialLinks] = useState({
    instagram: 'https://www.instagram.com/ella.gold.official',
    twitter: '',
    tiktok: '',
    discord: DISCORD_INVITE_URL,
    telegram: TELEGRAM_GROUP_URL
  });
  const audioRef = useRef(null);

  // Check if user is Gold member (based on loyalty level)
  const isGoldMember = user?.loyalty_level === 'gold' || user?.loyalty_level === 'diamond' || user?.is_admin;

  // Fetch social links from settings
  useEffect(() => {
    axios.get(`${API}/site-settings`)
      .then(res => {
        const social = res.data?.social || {};
        setSocialLinks(prev => ({
          ...prev,
          instagram: social.instagram || prev.instagram,
          twitter: social.twitter || '',
          tiktok: social.tiktok || '',
          discord: social.discord || prev.discord
        }));
      })
      .catch(() => {});
  }, []);

  // Fetch credit balance
  useEffect(() => {
    if (user) {
      const token = localStorage.getItem('token');
      axios.get(`${API}/credits/balance`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => setCreditBalance(res.data?.balance || 0))
        .catch(() => {});
    }
  }, [user]);

  // Direct purchase function
  const handleDirectPurchase = async (product) => {
    if (!user) {
      navigate('/login');
      return;
    }
    setPurchaseDialog(product);
  };

  const confirmDirectPurchase = async () => {
    if (!purchaseDialog) return;
    
    if (creditBalance < purchaseDialog.price) {
      setPurchaseDialog(null);
      navigate('/credits');
      return;
    }

    setPurchasing(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API}/credits/spend`, {
        product_id: purchaseDialog.id,
        credits_amount: purchaseDialog.price
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        setCreditBalance(response.data.new_balance);
        setPurchaseDialog(null);
        // Show success message
        alert(`🎉 ${purchaseDialog.name} purchased! Check your dashboard.`);
      }
    } catch (error) {
      console.error('Purchase error:', error);
      alert(error.response?.data?.detail || 'Purchase failed');
    } finally {
      setPurchasing(false);
    }
  };

  // ALWAYS use HARDCODED images - database is completely ignored
  const getImage = (location) => {
    return HARDCODED_IMAGES[location] || HARDCODED_IMAGES.hero;
  };

  // Get art collection images - ALWAYS hardcoded
  const getArtCollection = () => {
    return [
      HARDCODED_IMAGES.gallery_1,
      HARDCODED_IMAGES.gallery_2,
      HARDCODED_IMAGES.gallery_3,
      HARDCODED_IMAGES.gallery_4,
    ];
  };

  useEffect(() => {
    // Check age verification
    const ageVerified = localStorage.getItem('ella-gold-age-verified');
    if (!ageVerified) {
      setShowAgeCheck(true);
    }

    axios.post(`${API}/seed`).catch(() => {});
    
    // Skip loading site images from database - use hardcoded instead
    setImagesLoaded(true);
    
    // Initialize audio
    audioRef.current = new Audio('https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3');
    audioRef.current.loop = true;
    audioRef.current.volume = 0.3;
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
      }
    };
  }, []);

  const handleAgeConfirm = () => {
    localStorage.setItem('ella-gold-age-verified', 'true');
    setShowAgeCheck(false);
  };

  const handleAgeDecline = () => {
    window.location.href = 'https://www.google.com';
  };

  const toggleMusic = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch(() => {});
      }
      setIsPlaying(!isPlaying);
      setIsMuted(false);
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  // Show loading state while images load
  if (!imagesLoaded) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <Crown className="w-12 h-12 text-[#D4AF37] mx-auto mb-4 animate-pulse" />
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Gold Ambient Particles */}
      <div className="gold-particles" />
      
      {/* Age Verification Modal */}
      <Dialog open={showAgeCheck} onOpenChange={() => {}}>
        <DialogContent className="bg-[#0A0A0A]/95 backdrop-blur-xl border-[#D4AF37]/30 max-w-md text-center" hideClose>
          <DialogHeader>
            <DialogTitle className="text-white text-2xl flex flex-col items-center gap-4">
              <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#D4AF37]/30 to-[#D4AF37]/10 flex items-center justify-center animate-pulse-glow">
                <AlertTriangle className="w-12 h-12 text-[#D4AF37]" />
              </div>
              <span className="shimmer-text">{t('ageCheck.title') || '18+ Leeftijdsverificatie'}</span>
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-6 mt-4">
            <p className="text-gray-400 leading-relaxed">
              {t('ageCheck.description') || 'Deze website bevat content die alleen geschikt is voor volwassenen (18+). Door verder te gaan bevestig je dat je 18 jaar of ouder bent.'}
            </p>
            
            <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-xl text-sm text-red-400 backdrop-blur-sm">
              {t('ageCheck.warning') || 'Let op: Dit is een website met digitale kunstwerken voor volwassenen. Minderjarigen hebben geen toegang.'}
            </div>
            
            <div className="flex gap-3">
              <Button
                onClick={handleAgeDecline}
                variant="outline"
                className="flex-1 border-white/20 text-white hover:bg-white/10 rounded-full py-6 transition-all duration-300"
                data-testid="age-decline-btn"
              >
                {t('ageCheck.decline') || 'Nee, ik ben jonger dan 18'}
              </Button>
              <Button
                onClick={handleAgeConfirm}
                className="flex-1 btn-premium"
                data-testid="age-confirm-btn"
              >
                {t('ageCheck.confirm') || 'Ja, ik ben 18+'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Navbar />
      
      {/* Floating Music Control */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="glass-dark rounded-full px-5 py-3 flex items-center gap-4 shadow-2xl shadow-black/50 border border-white/10 hover:border-[#D4AF37]/30 transition-all duration-300">
          <span className="text-xs text-gray-400 hidden sm:block font-medium">♪ {t('music.title')}</span>
          <button
            onClick={toggleMusic}
            className="w-11 h-11 rounded-full bg-gradient-to-br from-[#D4AF37]/30 to-[#D4AF37]/10 hover:from-[#D4AF37]/40 hover:to-[#D4AF37]/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
            data-testid="music-toggle"
          >
            {isPlaying ? <Pause className="w-5 h-5 text-[#D4AF37]" /> : <Play className="w-5 h-5 text-[#D4AF37] ml-0.5" />}
          </button>
          <button
            onClick={toggleMute}
            className="w-9 h-9 rounded-full hover:bg-white/10 flex items-center justify-center transition-all duration-300"
          >
            {isMuted ? <VolumeX className="w-4 h-4 text-gray-400" /> : <Volume2 className="w-4 h-4 text-[#D4AF37]" />}
          </button>
        </div>
      </div>

      {/* HERO SECTION - UPGRADED */}
      <section className="relative min-h-screen overflow-hidden flex items-center">
        {/* Background Layers */}
        <div className="absolute inset-0">
          <FadeImage 
            src={getImage('hero')}
            alt="Digital Art"
            className="w-full h-full object-cover opacity-30 scale-105"
          />
          {/* Multiple gradient overlays for depth */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-transparent to-[#050505]/50" />
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_30%_50%,rgba(212,175,55,0.12)_0%,transparent_60%)]" />
        </div>
        
        {/* Animated glow orb */}
        <div className="hero-glow top-1/4 -left-32" />
        <div className="hero-glow bottom-1/4 right-0 animation-delay-3000" style={{ animationDelay: '3s' }} />

        {/* Hero Content */}
        <div className="relative z-10 w-full px-6 lg:px-20 py-32">
          <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Content */}
            <div className="lg:col-span-7 opacity-0 animate-slide-right" style={{ animationDelay: '0.2s' }}>
              {/* Badge */}
              <div className="glow-badge mb-8 inline-flex">
                <Crown className="w-4 h-4" />
                <span>{t('hero.badge')}</span>
              </div>
              
              {/* Main Title */}
              <h1 className="hero-title text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-medium tracking-tight mb-6">
                <span className="brand-ella text-white block">Ella</span>
                <span className="brand-gold text-7xl sm:text-8xl lg:text-9xl drop-shadow-[0_0_60px_rgba(212,175,55,0.4)]">Gold</span>
              </h1>
              
              {/* Subtitle */}
              <p className="hero-subtitle text-xl sm:text-2xl lg:text-3xl text-gray-200 mb-3 font-light">
                {t('hero.subtitle')}
              </p>
              <p className="text-base lg:text-lg text-gray-400 max-w-xl mb-10 leading-relaxed">
                {t('hero.description')}
              </p>

              {/* Token Info Card */}
              <div className="luxury-card p-5 mb-10 max-w-lg">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#D4AF37]/30 to-[#D4AF37]/10 flex items-center justify-center">
                    <Coins className="w-7 h-7 text-[#D4AF37]" />
                  </div>
                  <div>
                    <p className="text-[#D4AF37] font-semibold text-lg">{t('tokens.badge') || 'Ella Gold Tokens'}</p>
                    <p className="text-sm text-gray-400">{t('hero.tokenInfo') || 'Koop tokens en besteed ze op exclusieve content'}</p>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-wrap items-center gap-4 mb-10">
                <Button 
                  onClick={() => navigate('/gallery')}
                  className="btn-premium px-10 py-7 text-lg group"
                  data-testid="explore-cta"
                >
                  {t('hero.cta1')}
                  <ChevronRight className="ml-2 w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" />
                </Button>
                <Button 
                  onClick={() => navigate('/credits')}
                  variant="outline"
                  className="border-[#D4AF37]/40 hover:bg-[#D4AF37]/10 hover:border-[#D4AF37]/60 text-white px-10 py-7 text-lg rounded-full transition-all duration-300"
                  data-testid="buy-tokens-cta"
                >
                  <Coins className="w-5 h-5 mr-2 text-[#D4AF37]" />
                  {t('tokens.buyTokens') || 'Koop Tokens'}
                </Button>
              </div>
              
              {/* Social Links - Redesigned */}
              <div className="flex flex-wrap items-center gap-3">
                <a 
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#E4405F]/20 hover:border-[#E4405F]/50 transition-all duration-300 group"
                  data-testid="instagram-link"
                >
                  <Instagram className="w-5 h-5 text-gray-400 group-hover:text-[#E4405F] transition-colors" />
                </a>

                {socialLinks.twitter && (
                  <a 
                    href={socialLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:border-white/30 transition-all duration-300 group"
                    data-testid="twitter-link"
                  >
                    <XIcon className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
                  </a>
                )}

                {socialLinks.tiktok && (
                  <a 
                    href={socialLinks.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#ff0050]/20 hover:border-[#ff0050]/50 transition-all duration-300 group"
                    data-testid="tiktok-link"
                  >
                    <TikTokIcon className="w-5 h-5 text-gray-400 group-hover:text-[#ff0050] transition-colors" />
                  </a>
                )}

                <a 
                  href={socialLinks.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0088cc]/20 hover:border-[#0088cc]/50 transition-all duration-300 group"
                  data-testid="telegram-link"
                >
                  <TelegramIcon className="w-5 h-5 text-gray-400 group-hover:text-[#0088cc] transition-colors" />
                </a>
                
                {isGoldMember ? (
                  <a 
                    href={socialLinks.discord}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#5865F2]/20 hover:border-[#5865F2]/50 transition-all duration-300 group"
                    data-testid="discord-link-active"
                  >
                    <DiscordIcon className="w-5 h-5 text-gray-400 group-hover:text-[#5865F2] transition-colors" />
                  </a>
                ) : (
                  <div 
                    className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center opacity-50 cursor-not-allowed relative"
                    title={t('social.discordGoldOnly')}
                    data-testid="discord-link-locked"
                  >
                    <DiscordIcon className="w-5 h-5 text-gray-500" />
                    <Lock className="w-3 h-3 text-gray-500 absolute -top-1 -right-1 bg-[#050505] rounded-full p-0.5" />
                  </div>
                )}
              </div>
            </div>

            {/* Right Side - Stats Cards */}
            <div className="lg:col-span-5 hidden lg:block opacity-0 animate-slide-up" style={{ animationDelay: '0.5s' }}>
              <div className="grid grid-cols-2 gap-4">
                <div className="stat-glow col-span-2">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/20 flex items-center justify-center">
                      <Sparkles className="w-5 h-5 text-[#D4AF37]" />
                    </div>
                    <span className="text-gray-400 text-sm">Exclusieve Kunstwerken</span>
                  </div>
                  <p className="text-4xl font-bold shimmer-text">500+</p>
                </div>
                <div className="stat-glow">
                  <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/20 flex items-center justify-center mb-3">
                    <Star className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <p className="text-3xl font-bold text-white">4.9</p>
                  <p className="text-sm text-gray-400">Rating</p>
                </div>
                <div className="stat-glow">
                  <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/20 flex items-center justify-center mb-3">
                    <Crown className="w-5 h-5 text-[#D4AF37]" />
                  </div>
                  <p className="text-3xl font-bold text-white">VIP</p>
                  <p className="text-sm text-gray-400">Toegang</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-xs text-gray-500 tracking-widest uppercase font-medium">{t('common.scroll')}</span>
          <div className="w-6 h-10 rounded-full border-2 border-[#D4AF37]/30 flex justify-center pt-2">
            <div className="w-1.5 h-3 bg-[#D4AF37] rounded-full animate-bounce" />
          </div>
        </div>
      </section>

      {/* FEATURED: Token System - UPGRADED */}
      <section className="py-32 px-6 lg:px-20 relative overflow-hidden">
        {/* Background accent */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#D4AF37]/5 to-transparent pointer-events-none" />
        
        <div className="max-w-7xl mx-auto relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="opacity-0 animate-slide-right" style={{ animationDelay: '0.2s' }}>
              <div className="glow-badge mb-8 inline-flex">
                <Sparkles className="w-4 h-4" />
                <span>{t('featured.badge')}</span>
              </div>
              
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight mb-6">
                {t('featured.title')} <span className="shimmer-text text-5xl sm:text-6xl lg:text-7xl">{t('featured.titleAccent')}</span>
              </h2>
              <p className="text-gray-400 text-lg leading-relaxed mb-8">
                {t('featured.description')}
              </p>
              
              <ul className="space-y-4 mb-10">
                {(t('featured.features', { returnObjects: true }) || []).map((feature, i) => (
                  <li key={i} className="flex items-center gap-4 text-gray-300">
                    <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center">
                      <span className="w-2 h-2 bg-[#D4AF37] rounded-full" />
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
              
              {/* Token Pricing Cards */}
              <div className="flex flex-wrap items-stretch gap-4 mb-10">
                <div className="luxury-card p-5 flex-1 min-w-[120px]">
                  <div className="flex items-center gap-2 mb-2">
                    <Coins className="w-5 h-5 text-[#D4AF37]" />
                    <p className="text-3xl font-bold text-[#D4AF37]">3</p>
                  </div>
                  <p className="text-xs text-gray-400">Basic Pack</p>
                  <p className="text-xs text-gray-500">3 images</p>
                </div>
                <div className="luxury-card p-5 flex-1 min-w-[120px]">
                  <div className="flex items-center gap-2 mb-2">
                    <Coins className="w-5 h-5 text-[#D4AF37]" />
                    <p className="text-3xl font-bold text-[#D4AF37]">6</p>
                  </div>
                  <p className="text-xs text-gray-400">Premium Pack</p>
                  <p className="text-xs text-gray-500">8 + video</p>
                </div>
                <div className="luxury-card p-5 flex-1 min-w-[120px] border-[#D4AF37]/40">
                  <div className="flex items-center gap-2 mb-2">
                    <Coins className="w-5 h-5 text-[#D4AF37]" />
                    <p className="text-3xl font-bold text-[#D4AF37]">10</p>
                  </div>
                  <p className="text-xs text-[#D4AF37]">VIP Pack</p>
                  <p className="text-xs text-gray-500">15 + extras</p>
                </div>
              </div>
              
              <Button 
                onClick={() => navigate('/builder')}
                className="btn-premium px-10 py-7 text-lg group"
                data-testid="builder-cta"
              >
                <Sparkles className="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform" />
                {t('featured.cta')}
              </Button>
            </div>
            
            {/* Featured Image with Floating Card */}
            <div className="relative opacity-0 animate-scale-in" style={{ animationDelay: '0.4s' }}>
              <div className="aspect-square rounded-3xl overflow-hidden border border-[#D4AF37]/20 shadow-2xl shadow-[#D4AF37]/10">
                <FadeImage 
                  src={getImage('featured')}
                  alt="AI Art Preview"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              {/* Floating Stats Card */}
              <div className="absolute -bottom-8 -right-4 lg:-right-8 luxury-card p-6 shadow-2xl">
                <p className="text-sm text-gray-400 mb-1">Unieke combinaties</p>
                <p className="text-4xl font-bold shimmer-text">10,000+</p>
                <p className="text-xs text-gray-500 mt-1">mogelijkheden</p>
              </div>
              {/* Decorative element */}
              <div className="absolute -top-4 -left-4 w-24 h-24 border-2 border-[#D4AF37]/20 rounded-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider max-w-4xl mx-auto" />

      {/* Art Collection Preview - UPGRADED */}
      <section className="py-24 px-6 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-16 gap-4">
            <div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight mb-3">
                <span className="shimmer-text text-4xl sm:text-5xl lg:text-6xl">{t('collection.title')}</span> {t('collection.titleAccent')}
              </h2>
              <p className="text-gray-400 tracking-wide text-lg">{t('collection.subtitle')}</p>
            </div>
            <Link 
              to="/gallery"
              className="hidden sm:flex items-center gap-3 px-6 py-3 rounded-full border border-[#D4AF37]/30 text-[#D4AF37] hover:bg-[#D4AF37]/10 hover:border-[#D4AF37]/50 transition-all duration-300 group"
              data-testid="view-all-gallery"
            >
              <span className="text-sm font-medium tracking-wide">{t('collection.viewAll')}</span>
              <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Bento Grid for Art Collection */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {getArtCollection().map((img, index) => (
              <div 
                key={index}
                className={`group relative overflow-hidden rounded-2xl cursor-pointer ${
                  index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
                }`}
                onClick={() => navigate('/gallery')}
                data-testid={`art-card-${index}`}
              >
                <div className={`${index === 0 ? 'aspect-square' : 'aspect-square'} w-full`}>
                  <FadeImage 
                    src={img}
                    alt={`Digital Art ${index + 1}`}
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                  />
                </div>
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500" />
                {/* Border glow on hover */}
                <div className="absolute inset-0 border-2 border-[#D4AF37]/0 group-hover:border-[#D4AF37]/50 rounded-2xl transition-all duration-500" />
                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                  <span className="inline-block px-3 py-1.5 bg-[#D4AF37]/20 backdrop-blur-sm text-[#D4AF37] text-xs font-semibold rounded-full mb-2">
                    EXCLUSIVE
                  </span>
                  <h3 className={`${index === 0 ? 'text-2xl' : 'text-lg'} font-medium text-white`}>Art Piece #{index + 1}</h3>
                </div>
              </div>
            ))}
          </div>

          {/* Info Banner */}
          <div className="mt-16 luxury-card p-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-2">
              <Sparkles className="w-5 h-5 text-[#D4AF37]" />
              <p className="text-lg text-gray-300">{t('collection.info')}</p>
              <Sparkles className="w-5 h-5 text-[#D4AF37]" />
            </div>
          </div>
        </div>
      </section>

      {/* Subscription Plans - Now in TOKENS */}
      <section className="py-24 px-6 lg:px-20 bg-gradient-to-b from-transparent via-[#0A0A0A] to-[#050505]">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-4">
            {t('memberships.title')} <span className="brand-gold text-4xl sm:text-5xl">{t('memberships.titleAccent')}</span>
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto">
            {t('memberships.subtitle')}
          </p>
        </div>

        {/* Upgraded Pricing Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {[
            { key: 'dailyTease', tokens: 6, icon: '☕' },
            { key: 'midnightCrave', tokens: 10, icon: '🍺' },
            { key: 'pureObsession', tokens: 15, icon: '🎬', popular: true },
            { key: 'goldVip', tokens: 30, icon: '👑' },
          ].map((plan, index) => (
            <div 
              key={plan.key}
              className={`relative luxury-card p-8 ${
                plan.popular 
                  ? 'border-[#D4AF37]/50 lg:scale-105 z-10' 
                  : ''
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
              data-testid={`pricing-card-${plan.key}`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="px-5 py-1.5 bg-gradient-to-r from-[#D4AF37] to-[#FCD34D] text-black text-xs font-bold tracking-wider rounded-full flex items-center gap-1.5 shadow-lg shadow-[#D4AF37]/30">
                    <Star className="w-3 h-3" fill="currentColor" />
                    {t('memberships.popular')}
                  </span>
                </div>
              )}
              
              <div className="text-4xl mb-5">{plan.icon}</div>
              <h3 className="text-xl font-semibold mb-3">{t(`memberships.${plan.key}.name`)}</h3>
              
              <div className="flex items-baseline gap-2 mb-6">
                <Coins className="w-6 h-6 text-[#D4AF37]" />
                <span className={`text-5xl font-bold ${plan.popular ? 'shimmer-text' : 'text-[#D4AF37]'}`}>{plan.tokens}</span>
                <span className="text-sm text-gray-400">{t('tokens.tokenUnit')}</span>
              </div>
              
              <ul className="space-y-3 mb-8">
                {(t(`memberships.${plan.key}.features`, { returnObjects: true }) || []).map((feature, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-gray-300">
                    <span className="w-5 h-5 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full" />
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <Button 
                onClick={() => handleDirectPurchase({ id: `membership_${plan.key}`, name: t(`memberships.${plan.key}.name`), price: plan.tokens })}
                className={`w-full rounded-full py-6 ${
                  plan.popular 
                    ? 'btn-premium' 
                    : 'bg-white/5 hover:bg-white/10 text-white border border-white/10 hover:border-[#D4AF37]/30 transition-all duration-300'
                }`}
              >
                {t('memberships.subscribe')} - {plan.tokens} tokens
              </Button>
            </div>
          ))}
        </div>

        {/* Lifetime Access - Upgraded */}
        <div className="mt-20 max-w-3xl mx-auto">
          <div className="animated-border">
            <div className="p-10 text-center bg-[#0A0A0A] rounded-2xl">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-[#D4AF37]/30 to-[#D4AF37]/10 flex items-center justify-center float-animation">
                <Crown className="w-10 h-10 text-[#D4AF37]" />
              </div>
              <h3 className="text-3xl font-semibold mb-3">{t('lifetime.title')}</h3>
              <p className="text-gray-400 mb-6 max-w-md mx-auto">{t('lifetime.subtitle')}</p>
              
              <div className="flex items-center justify-center gap-3 mb-8">
                <Coins className="w-12 h-12 text-[#D4AF37]" />
                <span className="text-6xl font-bold shimmer-text">80</span>
                <span className="text-xl text-gray-400">{t('tokens.tokenUnit')}</span>
              </div>
              
              <Button 
                onClick={() => handleDirectPurchase({ id: 'lifetime_access', name: 'Lifetime Access', price: 80 })} 
                className="btn-premium px-12 py-7 text-lg"
                data-testid="lifetime-access-btn"
              >
                {user ? `${t('lifetime.cta')} - 80 tokens` : t('lifetime.cta')}
              </Button>
              
              {user && (
                <p className="text-sm text-gray-500 mt-4">
                  Jouw saldo: <span className="text-[#D4AF37] font-medium">{creditBalance}</span> tokens
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider max-w-4xl mx-auto" />

      {/* Loyalty Badges - UPGRADED */}
      <section className="py-24 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight mb-4">
              {t('rewards.title')} <span className="shimmer-text text-4xl sm:text-5xl lg:text-6xl">{t('rewards.titleAccent')}</span>
            </h2>
            <p className="text-gray-400 max-w-xl mx-auto text-lg">
              {t('rewards.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { key: 'bronze', icon: Award, color: '#CD7F32', gradient: 'from-[#CD7F32]/20 to-[#CD7F32]/5' },
              { key: 'silver', icon: Shield, color: '#C0C0C0', gradient: 'from-[#C0C0C0]/20 to-[#C0C0C0]/5' },
              { key: 'gold', icon: Crown, color: '#D4AF37', gradient: 'from-[#D4AF37]/20 to-[#D4AF37]/5' },
              { key: 'diamond', icon: Diamond, color: '#B9F2FF', gradient: 'from-[#B9F2FF]/20 to-[#B9F2FF]/5' },
            ].map((badge, index) => {
              const Icon = badge.icon;
              const rewardData = t(`rewards.${badge.key}`, { returnObjects: true });
              return (
                <div 
                  key={badge.key}
                  className="group relative p-8 rounded-2xl bg-gradient-to-b border border-white/10 hover:border-opacity-50 transition-all duration-500 hover:-translate-y-2"
                  style={{ 
                    borderColor: `${badge.color}30`,
                    background: `linear-gradient(135deg, ${badge.color}08 0%, transparent 50%)`
                  }}
                  data-testid={`loyalty-badge-${badge.key}`}
                >
                  {/* Glow effect on hover */}
                  <div 
                    className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    style={{ boxShadow: `inset 0 0 40px ${badge.color}15` }}
                  />
                  
                  <div className="relative text-center">
                    <div 
                      className="w-20 h-20 mx-auto mb-5 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-500"
                      style={{ background: `linear-gradient(135deg, ${badge.color}20 0%, ${badge.color}05 100%)` }}
                    >
                      <Icon 
                        className="w-10 h-10 transition-all duration-500" 
                        style={{ 
                          color: badge.color, 
                          filter: `drop-shadow(0 0 15px ${badge.color}60)` 
                        }} 
                      />
                    </div>
                    
                    <h3 className="text-xl font-semibold mb-2" style={{ color: badge.color }}>
                      {rewardData?.level || badge.key}
                    </h3>
                    <p className="text-sm text-gray-400 mb-3">
                      {rewardData?.min || ''} {t('rewards.spent') || 'spent'}
                    </p>
                    <p className="text-sm font-medium" style={{ color: badge.color }}>
                      {rewardData?.perks || ''}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Token Disclaimer Section - Upgraded */}
      <section className="py-20 px-6 lg:px-20">
        <div className="max-w-4xl mx-auto">
          <div className="luxury-card p-8 lg:p-10">
            <h3 className="text-xl font-semibold mb-6 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/10 flex items-center justify-center">
                <AlertTriangle className="w-5 h-5 text-[#D4AF37]" />
              </div>
              {t('disclaimer.tokenTitle') || 'Belangrijke Informatie over Ella Gold Tokens'}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-400">
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.noRefund') || 'Ella Gold Tokens zijn niet inwisselbaar voor geld en kunnen niet worden terugbetaald.'}
              </p>
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.noTransfer') || 'Tokens zijn niet overdraagbaar naar andere accounts of personen.'}
              </p>
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.digitalOnly') || 'Tokens kunnen uitsluitend worden besteed aan digitale producten en diensten op dit platform.'}
              </p>
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.noExpiry') || 'Tokens hebben geen vervaldatum en blijven onbeperkt geldig in je account.'}
              </p>
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.priceChange') || 'Prijzen van producten in tokens kunnen zonder voorafgaande kennisgeving worden gewijzigd.'}
              </p>
              <p className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />
                {t('disclaimer.adult') || 'Deze website en alle content is uitsluitend bedoeld voor personen van 18 jaar en ouder.'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - UPGRADED */}
      <footer className="py-20 px-6 lg:px-20 bg-gradient-to-t from-[#0A0A0A] to-transparent border-t border-white/5">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Crown className="w-10 h-10 text-[#D4AF37]" />
                <div>
                  <span className="brand-ella text-2xl">Ella</span>{' '}
                  <span className="brand-gold text-3xl">Gold</span>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed">
                {t('footer.tagline')}
              </p>
            </div>
            
            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-white">Snelle Links</h4>
              <div className="grid grid-cols-2 gap-3">
                <a href="/gallery" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Gallery</a>
                <a href="/credits" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Tokens</a>
                <a href="/packages" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Packages</a>
                <a href="/shop" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Shop</a>
                <a href="/how-it-works" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Aan de Slag</a>
                <a href="/contact" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">Contact</a>
              </div>
            </div>
            
            {/* Social & Contact */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-white">Volg Ons</h4>
              <div className="flex items-center gap-3 mb-6">
                <a 
                  href={socialLinks.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#E4405F]/20 hover:border-[#E4405F]/50 transition-all duration-300"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-5 h-5 text-gray-400 hover:text-[#E4405F]" />
                </a>
                {socialLinks.twitter && (
                  <a 
                    href={socialLinks.twitter} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 hover:border-white/30 transition-all duration-300"
                    data-testid="footer-twitter"
                  >
                    <XIcon className="w-5 h-5 text-gray-400" />
                  </a>
                )}
                {socialLinks.tiktok && (
                  <a 
                    href={socialLinks.tiktok} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#ff0050]/20 hover:border-[#ff0050]/50 transition-all duration-300"
                    data-testid="footer-tiktok"
                  >
                    <TikTokIcon className="w-5 h-5 text-gray-400" />
                  </a>
                )}
                <a 
                  href={socialLinks.telegram} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#0088cc]/20 hover:border-[#0088cc]/50 transition-all duration-300"
                  data-testid="footer-telegram"
                >
                  <TelegramIcon className="w-5 h-5 text-gray-400" />
                </a>
                {isGoldMember && (
                  <a 
                    href={socialLinks.discord} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-11 h-11 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-[#5865F2]/20 hover:border-[#5865F2]/50 transition-all duration-300"
                    data-testid="footer-discord"
                  >
                    <DiscordIcon className="w-5 h-5 text-gray-400" />
                  </a>
                )}
              </div>
              
              {/* Business Info */}
              <div className="text-sm text-gray-500">
                <p className="font-medium text-gray-400 mb-1">Ella Gold</p>
                <p>Torenallee 101, 5617BR Eindhoven</p>
                <p>KVK: 99681293</p>
              </div>
            </div>
          </div>
          
          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/5">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex flex-wrap justify-center gap-6">
                <a href="/terms" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Terms & Conditions
                </a>
                <a href="/privacy" className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors">
                  Privacy Policy
                </a>
              </div>
              <p className="text-sm text-gray-500">
                {t('footer.rights')}
              </p>
            </div>
            <p className="text-xs text-gray-600 mt-4 text-center">
              {t('footer.disclaimer')}
            </p>
          </div>
        </div>
      </footer>

      {/* Purchase Confirmation Dialog */}
      <Dialog open={!!purchaseDialog} onOpenChange={() => setPurchaseDialog(null)}>
        <DialogContent className="bg-[#0A0A0A] border-[#D4AF37]/30">
          <DialogHeader>
            <DialogTitle className="text-xl flex items-center gap-2">
              <Coins className="w-5 h-5 text-[#D4AF37]" />
              {t('tokens.confirmPurchase') || 'Confirm Purchase'}
            </DialogTitle>
          </DialogHeader>
          {purchaseDialog && (
            <PurchaseDialogContent 
              product={purchaseDialog} 
              creditBalance={creditBalance}
              onCancel={() => setPurchaseDialog(null)}
              onConfirm={confirmDirectPurchase}
              purchasing={purchasing}
              navigate={navigate}
              t={t}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Separate component for purchase dialog with discount calculation
function PurchaseDialogContent({ product, creditBalance, onCancel, onConfirm, purchasing, navigate, t }) {
  const { user } = useAuth();
  const [priceInfo, setPriceInfo] = useState(null);
  
  useEffect(() => {
    if (user && product) {
      const token = localStorage.getItem('token');
      axios.get(`${API}/price-preview/${product.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => setPriceInfo(res.data))
        .catch(() => setPriceInfo(null));
    }
  }, [user, product]);
  
  const finalPrice = priceInfo?.final_price ?? product.price;
  const hasDiscount = priceInfo?.has_discount && priceInfo.discount_percent > 0;
  
  return (
    <div className="space-y-4">
      <div className="p-4 bg-white/5 rounded-lg">
        <p className="text-lg font-medium">{product.name}</p>
        
        {hasDiscount ? (
          <div className="mt-2">
            <p className="text-sm text-gray-400 line-through">{product.price} tokens</p>
            <div className="flex items-center gap-2">
              <p className="text-3xl font-bold text-[#D4AF37]">{finalPrice} tokens</p>
              <span className="px-2 py-1 bg-green-500/20 text-green-400 text-sm rounded-full">
                -{priceInfo.discount_percent}% {priceInfo.loyalty_tier}
              </span>
            </div>
            <p className="text-xs text-green-400 mt-1">
              Je bespaart {priceInfo.discount_amount} tokens met je {priceInfo.loyalty_tier} korting!
            </p>
          </div>
        ) : (
          <p className="text-3xl font-bold text-[#D4AF37] mt-2">{product.price} tokens</p>
        )}
      </div>
      
      <div className="flex justify-between text-sm">
        <span className="text-gray-400">{t('tokens.yourBalance') || 'Your balance'}:</span>
        <span className={creditBalance >= finalPrice ? 'text-green-400' : 'text-red-400'}>
          {creditBalance} tokens
        </span>
      </div>
      
      {creditBalance < finalPrice && (
        <p className="text-red-400 text-sm">
          {t('tokens.insufficientTokens') || 'Not enough tokens!'} 
          <button onClick={() => { onCancel(); navigate('/credits'); }} className="text-[#D4AF37] ml-2 underline">
            {t('tokens.buyTokens') || 'Buy tokens'}
          </button>
        </p>
      )}
      
      <div className="flex gap-3 mt-6">
        <Button 
          variant="outline" 
          onClick={onCancel}
          className="flex-1 border-white/20"
        >
          {t('common.cancel') || 'Cancel'}
        </Button>
        <Button 
          onClick={onConfirm}
          disabled={purchasing || creditBalance < finalPrice}
          className="flex-1 bg-[#D4AF37] hover:bg-[#B8963A] text-black"
        >
          {purchasing ? 'Processing...' : 'Buy Now'}
        </Button>
      </div>
    </div>
  );
}
